import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "../../../utils/cn";
import { CheckIcon } from "../../icons/CheckIcon";
import { ErrorIcon } from "../../icons/ErrorIcon";

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  isValid?: boolean;
  hasError?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, isValid, hasError, ...props }, ref) => (
    <div className="relative w-full">
      <input
        ref={ref}
        className={cn(
          "w-full rounded-sm border border-muted bg-surface px-3 py-2 pr-8 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent",
          className,
        )}
        aria-invalid={hasError || undefined}
        {...props}
      />
      {hasError ? (
        <ErrorIcon className="absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-danger" />
      ) : isValid ? (
        <CheckIcon className="absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 text-success" />
      ) : null}
    </div>
  ),
);
Input.displayName = "Input";

export default Input;
